'use client';

import { useEffect } from 'react';
import { useAuth, useOrganizationList } from '@clerk/nextjs';

/**
 * Auto-selects the user's first organization when none is active in the session.
 */
export const useOrgAutoSelect = (hasOrg: boolean) => {
  const { orgId } = useAuth();
  const { userMemberships, setActive, isLoaded } = useOrganizationList({
    userMemberships: { pageSize: 1 },
  });

  useEffect(() => {
    if (!hasOrg || !isLoaded || orgId) return;

    const firstOrg = userMemberships?.data?.[0]?.organization;
    if (firstOrg && setActive) {
      setActive({ organization: firstOrg.id });
    }
  }, [hasOrg, isLoaded, orgId, userMemberships?.data, setActive]);

  return hasOrg && !!orgId;
};
